var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnlineLearning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5848",
    "data-name": "Group 5848",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 135.214,
    height: 150,
    viewBox: "0 0 135.214 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1450",
    "data-name": "Rectangle 1450",
    width: 135.214,
    height: 150,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5859",
    "data-name": "Group 5859",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5858",
    "data-name": "Group 5858"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5857",
    "data-name": "Group 5857",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5856",
    "data-name": "Group 5856",
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5855",
    "data-name": "Group 5855"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5854",
    "data-name": "Group 5854",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4596",
    "data-name": "Path 4596",
    d: "M105.869,40.292c13.809,17.013,28.17,30.38,29.275,44.962,1.1,14.472-11.047,30.159-24.967,42.532-13.809,12.483-29.5,21.763-45.4,22.2-16.018.332-32.257-8.285-44.188-20.768A74.8,74.8,0,0,1,.148,82.934C-.957,65.48,4.124,46.81,15.945,29.908,27.765,12.9,46.435-2.35,62.454.3c16.128,2.541,29.5,23.089,43.415,39.991",
    fill: "#0af"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_4597",
    "data-name": "Path 4597",
    d: "M93.611,69.06c-.3.027-.6.041-.916.055s-.683.027-1.052.027a28.376,28.376,0,0,1-3.538-.246V92.178a1.5,1.5,0,0,1-1.5,1.49H36.782a1.5,1.5,0,0,1-1.5-1.489V59.658a1.5,1.5,0,0,1,1.5-1.489H65.448a4.445,4.445,0,0,1,.041-2.159l.874-3.362H33.788a4.023,4.023,0,0,0-4.017,4.017V97.1H93.61Z",
    fill: "#2b528e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1448",
    "data-name": "Rectangle 1448",
    width: 13.273,
    height: 6.547,
    transform: "translate(55.056 102.793)",
    fill: "#2b528e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4598",
    "data-name": "Path 4598",
    d: "M99.1,113.633,94.021,99.149H29.362l-5.083,14.484a1.06,1.06,0,0,0,.138.943,1.03,1.03,0,0,0,.833.424h72.9a1.012,1.012,0,0,0,.957-1.367Zm-28.723-3.268a1.025,1.025,0,0,1-1.026,1.025H54.033a1.025,1.025,0,0,1-1.026-1.025v-8.6a1.025,1.025,0,0,1,1.026-1.024H69.355a1.025,1.025,0,0,1,1.026,1.024Z",
    fill: "#2b528e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4599",
    "data-name": "Path 4599",
    d: "M100.361,54.6,97.779,64.5c-1.689,6.32-26.966-.348-29.979-5.835a2.7,2.7,0,0,1-.328-2.1l2.582-9.865,12.161,10.18a3.14,3.14,0,0,0,1.982.71,2.612,2.612,0,0,0,.573-.054Z",
    fill: "#02e2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4600",
    "data-name": "Path 4600",
    d: "M86.984,43.815a1.79,1.79,0,0,0-2.281.954,1.782,1.782,0,0,0,1.523,1.947,1.831,1.831,0,0,0,2.281-.954C88.732,44.9,87.919,44.06,86.984,43.815Z",
    fill: "#2b528e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4601",
    "data-name": "Path 4601",
    d: "M110.824,66.95l-3.6-5.538V50.377a1.044,1.044,0,0,0-.369-.774L89.69,35.242a.969.969,0,0,0-.847-.219L66.831,39.137a1.025,1.025,0,0,0-.478,1.789L83.543,55.3a1.074,1.074,0,0,0,.846.219l20.785-3.9v9.791l-3.6,5.538a1.025,1.025,0,0,0,1.719,1.116l1.883-2.9v2.337a1.025,1.025,0,0,0,2.05,0V65.171l1.881,2.9a1.025,1.025,0,0,0,1.72-1.116ZM90.49,46.28A4.045,4.045,0,1,1,87.5,41.832,3.8,3.8,0,0,1,90.49,46.28",
    fill: "#2b528e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4602",
    "data-name": "Path 4602",
    d: "M40.936,73.542H66.693a1.024,1.024,0,0,0,1.025-1.025v-8.69A1.033,1.033,0,0,0,66.693,62.8H40.936a1.033,1.033,0,0,0-1.025,1.025v8.69a1.024,1.024,0,0,0,1.025,1.025",
    fill: "#2b528e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4603",
    "data-name": "Path 4603",
    d: "M39.913,78.5a1.025,1.025,0,0,0,1.025,1.025H82.45a1.025,1.025,0,0,0,0-2.05H40.938A1.025,1.025,0,0,0,39.913,78.5Z",
    fill: "#2b528e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4604",
    "data-name": "Path 4604",
    d: "M82.45,82.229H40.938a1.025,1.025,0,1,0,0,2.049H82.45a1.025,1.025,0,1,0,0-2.049",
    fill: "#2b528e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4605",
    "data-name": "Path 4605",
    d: "M82.45,86.979H40.938a1.025,1.025,0,1,0,0,2.049H82.45a1.025,1.025,0,1,0,0-2.049",
    fill: "#2b528e"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineLearning);
export default __webpack_public_path__ + "static/media/online-learning.3e8c219d486b22fa736c964889ce9e83.svg";
export { ForwardRef as ReactComponent };